export default __webpack_public_path__ + "static/media/celebrate.2e3133a4336ddc33a0039dc7f517103c.svg";